import { RootState } from "../../../system/redux/store/community-finder-redux-store";

export const selectModalOpen = (state: RootState) => state?.facets?.modalOpen;
